// useChangeHistory.js — 마케터 1:1 '변경 기록' 창 열기·불러오기 (2026-10-06 UX 5단계)
//   openAll(): 이 회사 기록 전체(최근 300건) / openForAssignment(row): 배정 하나의 기록
//   요청 주소는 서버에 이미 있는 두 곳 — 회사 기록(…/logs), 배정 기록(…/assignments/:id/logs)
import { useRef, useState } from 'react';
import { apiClient } from '../../../api/apiClient';
import { withIntegratedMenu } from './marketerConsultantPageUtils';

const CLOSED = { open: false, scope: 'all', row: null, logs: [], loading: false, error: '' };

export function useChangeHistory({ companyCode, integratedMenuId = null }) {
  const [state, setState] = useState(CLOSED);
  const requestNo = useRef(0); // 창을 닫았다 다시 열면 늦게 온 옛 응답은 버린다

  async function load(scope, row, url) {
    const no = requestNo.current + 1;
    requestNo.current = no;
    setState({ open: true, scope, row, logs: [], loading: true, error: '' });
    const res = await apiClient.get(withIntegratedMenu(url, integratedMenuId));
    if (requestNo.current !== no) return;
    setState((prev) => ({
      ...prev,
      loading: false,
      logs: res.ok && Array.isArray(res.data) ? res.data : [],
      error: res.ok ? '' : (res.data?.message || '변경 기록을 불러오지 못했습니다.'),
    }));
  }

  function openAll() {
    return load('all', null, `/api/admin/marketer-consultant/logs?company_code=${encodeURIComponent(companyCode)}`);
  }

  function openForAssignment(row) {
    if (!row?.id) return null;
    return load('assignment', row, `/api/admin/marketer-consultant/assignments/${Number(row.id)}/logs`);
  }

  function close() {
    requestNo.current += 1;
    setState(CLOSED);
  }

  return { ...state, openAll, openForAssignment, close };
}
